import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SelectFilterAsync } from '@flightstats/component-lib';
import { identity, path, pathOr, pathSatisfies } from 'ramda';
import SearchSource from '../../sources/search';
import onResize from '../../lib/on-resize';
import componentBase from '../../lib/component-base';

@onResize()
@componentBase('AsyncElasticsearchSelect')
export default class AsyncElasticsearchSelect extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    input: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    inputTitle: PropTypes.string,
    selectedItem: PropTypes.object,
    noResultsTexts: PropTypes.object,
    placeholder: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
    secondaryAction: PropTypes.func,
    queryFormatter: PropTypes.func.isRequired,
    itemFormatter: PropTypes.func.isRequired,
    searchSource: PropTypes.string.isRequired,
    styleProps: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    const { selectedItem } = props;
    const isLoading = false;
    const noResults = false;
    if (selectedItem) {
      this.state = { value: selectedItem.value, results: [selectedItem], isLoading, noResults };
    } else {
      this.state = { value: null, results: [], isLoading, noResults };
    }
  }

  componentDidMount() {
    this.initResizeListener();
    this.changeInput(this.props);
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.input !== nextProps.input) {
      this.changeInput(nextProps);
    }
  }

  componentWillUnmount() {
    this.removeResizeListener();
    this.mounted = false;
  }

  onBlur = (event) => {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }

  onChange = (option, triggeredByEnter) => {
    const optionValue = (option && option.value);

    this.setState({ value: optionValue });

    if (this.props.onChange) {
      return this.props.onChange(option, triggeredByEnter);
    }
  };

  onDelete = (option) => {
    const optionValue = (option && option.value);

    this.setState({ value: optionValue });

    if (this.props.onDelete) {
      // originally, delete was handled by onChange, might not be updated everywhere
      return this.props.onDelete(option);
    } else if (this.props.onChange) {
      // fallback to onChange (original delete handler)
      return this.props.onChange(option);
    }
  }

  getOptions = (input) => {
    const [serverTime] = this.setServerTime();
    const isLoading = !this.state.isLoading;
    this.setState({
      isLoading,
      noResults: false,
    });
    SearchSource[this.props.searchSource](this.props.queryFormatter ?
      this.props.queryFormatter(input) :
      input, serverTime)
      .then((res) => {
        this.handleAsyncResults(this.buildOptions(res));
      })
      .catch((ex) => {
        this.exception(ex);
        this.handleAsyncResults(this.buildOptions({}));
      });
  };

  setServerTime = () => ([pathOr(identity({}), ['store', 'getState'], this.context)]
    .map(f => f())
    .map(t => path(['Account', 'serverTime'], t))
  )

  setValueState = (newValue) => {
    if (this.mounted) {
      this.setState({ value: newValue });
    } else {
      this.state.value = newValue;
    }
  }

  secondaryAction = () => {
    const { secondaryAction } = this.props;
    secondaryAction && secondaryAction();
  }

  mobileScreen = () => [path(['mediaBreakpoint', 'isMobile'], this),
    pathSatisfies(val => val < 769, ['mediaBreakpoint', 'value'], this)]
    .some(val => val)

  handleResize = () => {
    this.forceUpdate();
  }

  handleAsyncResults = results => this.setState({
    noResults: (!results || !results.length),
    isLoading: false,
    results,
  });

  changeInput(props) {
    if (props && props.input) {
      if (props.initializerSource) {
        const [serverTime] = this.setServerTime();
        SearchSource[props.initializerSource](props.input, serverTime)
          .then((res) => {
            this.setValueState(res.data);
          })
          .catch(() => {
          });
      } else {
        this.setValueState(props.input);
      }
    } else {
      // empty
      this.setValueState(null);
    }
  }

  buildOptions = (res) => {
    const { data = [] } = res;
    return data.map(item => ({
      value: item,
      label: this.props.itemFormatter(item),
    }));
  };

  render() {
    const isMobile = this.mobileScreen();
    const {
      inputTitle,
      name,
      noResultsTexts,
      placeholder,
      styleProps = {},
    } = this.props;
    const { isLoading, noResults } = this.state;
    const {
      bgColor,
      placeholderColor,
      textColor,
      iconColor,
      height,
      borderColor,
    } = styleProps;

    return (
      <div>
        <SelectFilterAsync
          isLoading={isLoading}
          clearable
          searchable
          noResults={noResults}
          noResultsTexts={noResultsTexts}
          ref={`async-elasticsearch-select-${name}`}
          hideCaret
          value={this.state.value}
          results={this.state.results}
          handleChange={this.getOptions}
          handleMenuSelection={this.onChange}
          handleRemoveSelection={this.onDelete}
          inputTitle={inputTitle}
          placeholder={placeholder}
          height={height}
          menuWidth='100%'
          borderColor={borderColor || 'white'}
          bgColor={bgColor || 'hsla(0,0%,75%,.66)'}
          placeholderColor={placeholderColor || 'white'}
          iconColor={iconColor || 'white'}
          isMobile={isMobile}
          textColor={textColor || 'white'}
          selectWrapperPosition='relative'
          secondaryAction={this.secondaryAction}
          onBlur={this.onBlur}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/lib/AsyncElasticsearchSelect.js